import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {IATA_SERVICE_TOKEN} from "../shared/services/iata.service";
import {NotificationsService,  SpinnerComponent as Spinner} from "@westjetairlines/wjesd-component-library";

@Component({
  selector: 'app-iata-admin',
  templateUrl: './import-iata.component.html',
  styleUrls: ['./import-iata.component.css']
})
export class ImportIataComponent implements OnInit {
  @ViewChild('fileinput') nativeFileInput: any;
  fileInput: Blob;
  canImport: boolean = false;

  constructor(@Inject(IATA_SERVICE_TOKEN) private iataService, private notificationService: NotificationsService)
  {
  }

  ngOnInit() {
  }

  onFileChange(input) {
    this.notificationService.clear();
    this.canImport = (input !== null && typeof input.files[0] !== "undefined") && input.files.length === 1 && input.files[0].name.toLocaleLowerCase().endsWith('.csv');
    this.fileInput = input != null ? input.files[0] : null;
  }

  onImport() {
    let self = this;
    let reader = new FileReader();

    reader.onload = ((event: any) => {
      let content = event.target.result;
      self.import(content);
    });
    reader.readAsText(self.fileInput);
  }

  import(input) {
    if (input != null) {
      this.notificationService.clear();
      Spinner.start();
      this.iataService.importIata(input).subscribe(result => {
        if(result.wasSuccessful) {
          this.notificationService.success(`You have successfully imported ${result.value.Success} IATA numbers. Your file contained ${result.value.Failures} errors and ${result.value.Skipped} empty rows.`);
          this.nativeFileInput.nativeElement.value = "";
          this.fileInput = null;
          this.canImport = false;
        } else {
          this.notificationService.error(result.brokenRules[0].message);
        }
          },
          err => {
            console.log('error', err);
            this.notificationService.error(err);
            Spinner.stop();
          },
          () => {
            Spinner.stop();
          });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/import-iata/import-iata.component.ts